<div *ngIf="uploadBatchState?.uploadBatches.length !== 0" id="analytics-page-wrapper"
  style="display: flex; flex-direction: column; height: calc(100% - 6vh); overflow: auto; margin: 2.2vh 4px 0 0;">
  <div style="display: flex; flex-direction: column; justify-content: center; padding: 6px 4px 0 16px;">
    <div id="analytics-header" style="font-size: clamp(24px, 3vh, 26px); padding: 0px 0 1.2vh 16px;">
      <span><i id="analytics-icon" class="fa-duotone fa-magnifying-glass-chart" style="font-size: 1.2em;"></i></span>
      <div style="padding-left: 10px; align-self: flex-end;">
        <div id="analytics-name">Case Analytics</div>
      </div>
    </div>
    <div id="analytics-item-wrapper"
      style="display: flex; flex-wrap: wrap; gap: 10px; width: calc(100% - 16px); padding: 4px 10px 12px 0;">
      <div class="analytics-card-wrapper">
        <mat-card class="analytics-card">
          <mat-card-content style="height: 100%">
            <lex-case-analytics-uploads class="analytics-graph-component"
              [uploadBatchState]="uploadBatchState"></lex-case-analytics-uploads>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="analytics-card-wrapper">
        <mat-card class="analytics-card">
          <mat-card-content style="height: 100%">
            <lex-case-analytics-review-sets class="analytics-graph-component"
              [reviewSetState]="reviewSetState"></lex-case-analytics-review-sets>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="analytics-card-wrapper">
        <mat-card class="analytics-card">
          <mat-card-content style="height: 100%">
            <lex-case-analytics-productions class="analytics-graph-component"
              [productionJobState]="productionJobState"></lex-case-analytics-productions>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div id="analytics-item-wrapper"
      style="display: flex; flex-wrap: wrap; gap: 10px; width: calc(100% - 16px); padding: 0 10px 12px 0;">
      <div class="analytics-card-wrapper">
        <mat-card class="analytics-card">
          <mat-card-content style="height: 100%">
            <lex-case-analytics-custodians class="analytics-graph-component"
              [custodianState]="custodianState"></lex-case-analytics-custodians>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="analytics-card-wrapper">
        <mat-card class="analytics-card">
          <mat-card-content style="height: 100%;">
            <lex-case-analytics-review-documents class="analytics-graph-component"
              [reviewDocumentState]="reviewDocumentState"></lex-case-analytics-review-documents>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div id="analytics-item-wrapper"
      style="display: flex; flex-wrap: wrap; gap: 10px; width: calc(100% - 16px); padding: 0 10px 12px 0;">
      <div class="analytics-card-wrapper">
        <mat-card class="analytics-card">
          <mat-card-content style="height: 100%">
            <lex-case-analytics-collection-summary
              [collectionSummaryState]="collectionData"></lex-case-analytics-collection-summary>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</div>
<div *ngIf="uploadBatchState?.uploadBatches.length < 1 && !isLoading" id="no-uploads-message"  class="full-page-body-height"  style="display: flex; flex-direction: column; 
    align-items: center; justify-content: center;" [@appear]>
  <div class="lex-mdc-toolbar-card-box" style="height: 40%; min-height: 180px;">
    <mat-toolbar class="lex-theme-font-softer" style="gap: 10px; align-items: baseline;">
      <div style="display: flex; flex-direction: row; height: 100%; align-items: center;">
        <i class="fa-duotone fa-solid fa-seedling icon"></i>
      </div>
      <div class="primary-text" style="display: flex; align-items: center; height: 50%;">There's nothing to display yet.</div>
    </mat-toolbar>
    <mat-card style="height: 60%">
      <mat-card-content class="lex-theme-font--softer">
        <div style="min-height: 30%; display: flex; flex-direction: column; gap: 8px;">
          <div>Metrics measured from raw case data will be gathered and reported here to provide insights into
            case collections.</div>
          <div>Analytics reporting will begin after files have been uploaded.</div>
        </div>
        <div *inRole="[roles.DeleteDocFeatureSet]" style="display: flex; flex-direction: column; width: 100%; align-items: center;">
          <button mat-flat-button class="mat-raised-button  no-data-button">
            <a class="lex-button-link" style="display: flex; width: 300px;" [routerLink]="['/', 'case', 'uploads']">
              <div body-subject style="width: 100%;">
                <div style="display: flex; justify-self: center; width: calc(100% - 16px);">
                  <i class="fa-duotone fa-file-import front-and-center" style="font-size: 20px; padding-right: 8px;"></i>
                  <div>
                    <b>Upload some documents</b>
                  </div>
                </div>
              </div>
            </a>
          </button>
          <div style="padding-top: 5px; opacity: 0.85; font-size: 0.9em">
            To start seeing reports generated for this case
            </div>
        </div>
        </mat-card-content>
    </mat-card>
  </div>
</div>
